"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EmblemFrame = _interopRequireDefault(require("./EmblemFrame"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _EmblemFrame.default;
exports.default = _default;